import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetAllPoliciesForCSVResponse {
  name: string;
  description: string;
  classes?: Array<string>;
  events?: Array<string>;
}
export const getAllPoliciesForCSVAPI = async () => {
  const response = await baseAPI.get<Array<GetAllPoliciesForCSVResponse>>(
    `/policies/studio/all/csv`,
  );
  return response.data;
};

export const getAllPoliciesForCSVQueryOptions = (enabled: boolean) =>
  queryOptions({
    queryKey: [KEYS.POLICIES_CSV],
    queryFn: () => getAllPoliciesForCSVAPI(),
    enabled: enabled,
  });

export const useGetAllPoliciesForCSV = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    ...getAllPoliciesForCSVQueryOptions(enabled),
  });
};
